/**
 * Wedding date field, checkout gating and the dispatch-date warning.
 *
 * Loaded on every page from snippets/scripts.liquid. It MUST live here rather than inline in
 * snippets/cart-summary.liquid: the theme rebuilds the cart with replaceChildren(), and an
 * inline <script> inside replaced markup never runs again. That is why the warning and the
 * disabled checkout button worked only sometimes — whenever the page happened to load with the
 * cart markup already present. Moved out 9 October 2026.
 *
 * Nothing here blocks on the VALUE of the wedding date. Checkout is gated only on the field
 * being filled in. The date conflict is a warning and leaves the button alone.
 */
(function () {
  'use strict';

  function cartUpdateUrl() {
    var r = window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url;
    return (r || '/cart/update') + '.js';
  }

  function post(attributes) {
    fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
  }

  /* Mirror the displayed dispatch date onto the order. The value comes from Liquid, never from
     Date() here, so the bride's timezone cannot shift it off the shop's. */
  function recordDispatchDate() {
    var el = document.querySelector('.cart-dispatch-date');
    if (!el) return;
    var shown = el.dataset.dispatchDate;
    if (!shown || window.__hlDispatchRecorded === shown) return;
    window.__hlDispatchRecorded = shown;
    post({ 'Expected dispatch by': shown });
  }

  function sync() {
    document.querySelectorAll('.cart-wedding-date').forEach(function (wrap) {
      var input = wrap.querySelector('input[name="attributes[Wedding Date]"]');
      if (!input) return;

      /* Paired by position, never by id: the cart page and the drawer both render this markup
         and the theme's checkout button carries the same id in each. */
      var scope    = wrap.parentElement;
      var ctas     = scope ? scope.querySelector('.cart__ctas') : null;
      var btn      = ctas ? ctas.querySelector('button[name="checkout"]') : null;
      var express  = ctas ? ctas.querySelector('.additional-checkout-buttons') : null;
      var hint     = wrap.querySelector('.cart-wedding-date__hint');
      var conflict = wrap.querySelector('.cart-wedding-date__conflict');

      var cartEmpty = wrap.dataset.cartEmpty === 'true';
      var block = cartEmpty || !input.value;

      /* Every write is guarded, because this runs from a MutationObserver and an unguarded
         write would retrigger it. */
      if (btn && btn.disabled !== block) {
        btn.disabled = block;
        btn.setAttribute('aria-disabled', block ? 'true' : 'false');
      }

      /* Shop Pay, PayPal and Google Pay submit straight to checkout and ignore a required
         field, so they are held back too. */
      if (express) {
        var pe = block ? 'none' : '';
        if (express.style.pointerEvents !== pe) {
          express.style.pointerEvents = pe;
          express.style.opacity = block ? '0.4' : '';
          express.setAttribute('aria-hidden', block ? 'true' : 'false');
        }
      }

      var hintHidden = cartEmpty || !!input.value;
      if (hint && hint.hidden !== hintHidden) hint.hidden = hintHidden;

      /* ISO dates compare correctly as plain strings, so there are no Date objects and no
         timezone to get wrong. The dispatch value is rendered by Liquid in the shop's timezone. */
      if (conflict) {
        var dispatchEl = scope ? scope.querySelector('.cart-dispatch-date') : null;
        var iso = dispatchEl ? dispatchEl.dataset.dispatchIso : '';
        var clash = !!(input.value && iso && input.value < iso);
        if (conflict.hidden === clash) conflict.hidden = !clash;
      }

      if (!input.dataset.hlBound) {
        input.dataset.hlBound = '1';
        input.addEventListener('input', sync);
        input.addEventListener('change', function () {
          sync();
          /* Keep the drawer and the cart page in step before the next re-render. */
          document.querySelectorAll('input[name="attributes[Wedding Date]"]').forEach(function (other) {
            if (other !== input) other.value = input.value;
          });
          post({ 'Wedding Date': input.value });
        });
      }
    });

    recordDispatchDate();
  }

  var pending;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(sync, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  /* The cart is rebuilt rather than updated in place, so watch for it rather than assuming
     this script's own markup survives. Debounced, because the cart and Easify both mutate a lot. */
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
